import { ErrorBoundary } from '@flos/react-ui';
import ErrorModal from '../ErrorModal/ErrorModal';
import { useContext } from 'react';
import LoggerContext from '../../context/LoggerContext';

const ErrorBoundaryComponent = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
    const logger = useContext(LoggerContext);
    return (
        <ErrorBoundary
            fallbackUi={({ retry }) => {
                return <ErrorModal retry={retry} />;
            }}
            logger={logger}
        >
            {children}
        </ErrorBoundary>
    );
};

export default ErrorBoundaryComponent;
